import React from 'react';
import { ReactComponent as ArrayIcon } from '../../../../../../assets/main/groups/main-table/array.svg';
import { NavLink, useParams } from 'react-router-dom';
import { Student } from 'features/model/types/studentsSchema';

interface StudentsItemProps {
    student: Student | null | undefined;
}

export const StudentsItem = ({ student }: StudentsItemProps): JSX.Element | null => {
    const { groupId } = useParams();

    if (!student) {
        return null;
    }

    return (
        <div className="row" key={student.id}>
            <div className="col student-col full-width-mobile">
                <span className="col-title">Студент</span>
                <div className="student-data-box">
                    <div className="avatar">
                        <img src={student.avatar} alt={student.fullName} />
                        <span className={`status-label ${student.onlineStatus}`} />
                    </div>
                    <div className="student-data">
                        <p className="name">
                            <NavLink to={`/groups/${groupId}/students-pages/${student.id}`}>
                                {student.fullName}
                            </NavLink>
                        </p>
                        {student.phone !== null && (
                            <p className="phone">
                                <a href={`tel:${student.phone}`}>{student.phone}</a>
                            </p>
                        )}
                        <div className="data-statistic">
                            {student.cuts !== null && (
                                <div className="data-statisitc-item">
                                    <span className="data-statistic-text">Срезы </span>
                                    <span
                                        className={`data-statistic-val completed-count ${student.cuts > 50 ? '' : 'low'}`}
                                    >
                                        {student.cuts}%
                                    </span>
                                </div>
                            )}
                            {student.efficiency !== null && (
                                <div className="data-statisitc-item">
                                    <span className="data-statistic-text">Эффективность </span>
                                    <span
                                        className={`data-statistic-val completed-count ${student.efficiency > 50 ? '' : 'low'}`}
                                    >
                                        {student.efficiency}%
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
            <div className="col first-level-col">
                <span className="col-title">Начальный уровень</span>
                <p>{student.beginningLanguageLevel}</p>
            </div>
            <div className="col current-level-col">
                <span className="col-title">Текущий уровень</span>
                <p>{student.currentLanguageLevel}</p>
            </div>
            <div className="col classes-attended-col align-right">
                <span className="col-title">Посещенные занятия</span>
                <p>{student.attendedClasses}</p>
            </div>
            <div className="col passes-col align-right">
                <span className="col-title">Пропуски</span>
                <p>{student.missingClasses}</p>
            </div>
            <div className="col hometasks-col align-right">
                <span className="col-title">Домашние задания</span>
                <p>{student.homeworks}/{student.homeworksAll}</p>
            </div>
            <NavLink to={`/groups/${groupId}/students-pages/${student.id}`}>
                <div className="col btn-link-col">
                    <span className="circle-arrow-btn">
                        <ArrayIcon />
                    </span>
                </div>
            </NavLink>
        </div>
    );
};
